

















































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import SimpleDialog from '@c/SimpleDialog.vue';
import WaterfallDiagram from './WaterfallDiagram.vue';
import {DateTimeInterval} from '@/utils/dateTimeItervalUtils';
import {WaterfallDiagramData} from './interfaces';
import Loading from '@c/controls/Loading.vue';
import Card from '@c/Card.vue';
import {
  DtcpAcceleromerModuleAxisType,
  SpectrumEventType,
  SpectrumIntervalAggregateType,
  SpectrumYAxisType,
} from '@/enums/diagrams';
import waterfallDiagramStoreModule from '@/store/modules/waterfallDiagramModule';
import {WaterfallSettings} from './interfaces';
import {flatten} from 'lodash';
import {IndexInterval} from '@u/indexInterval';
import enumsModule from '@/store/modules/enumsModule';
import {
  dtcpAccelerometerAxisTypes,
  spectrumIntervalAggregateTypes,
  waterfallTaskStatusList,
} from './configurate';
import {WaterfallTaskStatus} from './enums';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {getAccelerometerApiStore} from '@c/diagrams/utils';
import {PModuleType} from '@/enums/configs';
import {WaterfallSpectrumDiagramData} from '@c/diagrams/interfaces';

@Component({
  components: {
    SimpleDialog,
    WaterfallDiagram,
    Loading,
    Card,
  },
})
export default class VibrationWaterfallBox extends Vue {
  //Выбранный временной интервал
  @Prop({required: false})
  selectedInterval!: DateTimeInterval;

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  // Диаграмма
  @Prop({required: true})
  diagram!: WaterfallSpectrumDiagramData;

  // Id программного модуля
  @Prop({required: true})
  pmoduleAccelerometer!: PModuleWithMeasurements;

  // Id тахометра для
  @Prop({required: true})
  pmoduleTaho!: PModuleWithMeasurements;

  // Диалоговое окно для установки параметров
  paramsDialog = false;

  @Watch('resizedKey')
  onChangedParams() {
    if (
      !this.selectedInterval ||
      !this.selectedInterval.startDateTime ||
      !this.selectedInterval.endDateTime ||
      !this.diagram
    )
      return;
    this.xSoftMin = this.selectedInterval.startDateTime;
    this.xSoftMax = this.selectedInterval.endDateTime;
  }

  @Watch('paramsDialog')
  onParamsDialogChanged(value: boolean) {
    // TODO: зачем нужен copiedSpectrumType ?
    if (value) this.copiedSpectrumType = this.spectrumType;
  }

  // Показатель выбора Dtcp акселерометра
  get isDtcpAccelerometer() {
    return this.pmoduleAccelerometer.type == PModuleType.DtcpAccelerometerModule;
  }

  formValid = false;

  error = false;

  isRendering = false;

  isRecalcLoading = false;

  isError = false;

  // Значение soft min и soft max оси x, нужно для того, чтобы при отсутствии данных показывать полный период
  xSoftMin: any = null;
  xSoftMax: any = null;

  // Данне диаграммы
  chartData: WaterfallDiagramData = {id: '', data: [], minAmplitude: 0, maxAmplitude: 0};

  // номер итерации
  progress = 0;

  //всего итераций
  total: number | null = null;

  // статус выполенния
  status = '';

  // тип спектра
  spectrumType = SpectrumEventType.Low;

  //TODO: зачем нужен copiedSpectrumType ?
  copiedSpectrumType = SpectrumEventType.Low;

  //Тип агрегации для графика водопада спектров по умолчанию
  aggregateType = SpectrumIntervalAggregateType.Avg;

  //Тип оси для Dtcp акселерометра
  axisType = DtcpAcceleromerModuleAxisType.X;

  //Ожидаемое кол-во строк в таблице - т. е. частот
  heightToKeep = 50;

  //Ожидаемое кол-во колонок в таблице - т. е. временных интервалов
  widthToKeep = 250;

  //Параметр параллелизации
  parallelFactor = 8;

  // Смещение по частоте, сколько первых значений не брать
  offset = 0;

  maxY = 2000;

  dataLength = 0;

  rowsize = 1;

  colsize = 1;

  minY = 0;

  minYChart = 0;

  maxYChart = 2000;

  //Коэффициент прореживания
  thiningFactor: number | null = null;

  evtSource: EventSource | null = null;

  // Минимальное значение масштаба по оси X (мс)
  xMinScaleValue = 1000;

  // Минимальное значение масштаба по оси Y
  yMinScaleValue = 1;

  // Показатель того, что применен зум
  isInZoom = false;

  // Тип измерения спектра (Виброускорение\Виброскорость)
  spectrumYAxisType: SpectrumYAxisType = SpectrumYAxisType.VAcceleration;

  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';

  positiveNumberRule = (v: any) => v === null || v > 0 || 'Поле должно быть положительным числом';

  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';

  mounted() {
    this.$nextTick(() => {
      if (
        !this.selectedInterval ||
        !this.selectedInterval.startDateTime ||
        !this.selectedInterval.endDateTime ||
        !this.diagram
      )
        return;
      this.xSoftMin = this.selectedInterval.startDateTime;
      this.xSoftMax = this.selectedInterval.endDateTime;
    });
  }

  // Идентификтор запущенной задачи на получение данных для графика водопада спектров
  get taskCode() {
    return waterfallDiagramStoreModule.getTaskCode;
  }

  // Показатель выполнения расчета спектра
  get isTaskRunning() {
    return this.status === WaterfallTaskStatus.Running;
  }

  // Список типов спектра
  get spectrumEventTypes() {
    return enumsModule.spectrumTypes;
  }

  // Список типов агрегации
  get spectrumIntervalAggregateTypes() {
    return spectrumIntervalAggregateTypes;
  }

  // Список типов оси для 3х осного акселерометра
  get dtcpAccelerometerAxisTypes() {
    return dtcpAccelerometerAxisTypes;
  }

  // Статус расчета спектра
  get statusName() {
    const status = waterfallTaskStatusList.find((item: any) => item.value === this.status);
    return status ? status.name : '';
  }

  // Прогресс расчета спектра
  get countProgress() {
    return this.total ? `${((this.progress / this.total) * 100).toFixed()} %` : '0 %';
  }

  // TODO: Рефакторинг
  // Действия при изменении измерения (Виброускорение\Виброскорость)
  async changeYAxisType(params: {value: SpectrumYAxisType; recalc: boolean}) {
    this.spectrumYAxisType = params.value;

    try {
      this.isRecalcLoading = true;
      /* Пока непонятно, сто со всем этим делать:

      const points = this.chartData.data.map(p => [p[2], p[1], p[0]]);

      const data = await getAccelerometerApiStore(this.pmoduleAccelerometer.type).recalcSpectrum({
        id: this.pmoduleAccelerometer.id ?? 0,
        spectrum: points,
        length: this.dataLength,
        left: this.minY,
        right: this.maxY,
        spectrumValueType: this.spectrumYAxisType,
      });

      const transformPoints = data.map((p: any) => [p[2], p[1], p[0]]);

      const minAmplitude = Math.min(...transformPoints.map((p: any) => p[2]));
      const maxAmplitude = Math.max(...transformPoints.map((p: any) => p[2]));

      this.chartData = {data: transformPoints, minAmplitude, maxAmplitude, id: this.diagram.id};
      */
    } catch {
      this.isError = true;
    } finally {
      this.isRecalcLoading = false;
    }
  }

  @Watch('taskCode')
  async onChangedTaskCode(newVal: string) {
    if (newVal) await this.connectSSE(newVal);
  }

  async connectSSE(taskCode: string) {
    this.closeSSE();

    this.evtSource = await getAccelerometerApiStore(
      this.pmoduleAccelerometer.type,
    ).getIntervalSpectrumTaskStatusSSE({id: this.pmoduleAccelerometer.id ?? 0, taskCode});
    this.evtSource.onmessage = async response => {
      try {
        if (response.data) {
          // TODO когда с сервера будет приходить строка с валидным json можно убрать.
          const value = JSON.parse(response.data.replaceAll("'", '"'));

          if (value) {
            this.status = value.status;
            if (this.status === WaterfallTaskStatus.Completed) {
              const rawData = await waterfallDiagramStoreModule.getResult({
                accelerometerId: this.pmoduleAccelerometer.id ?? 0,
                taskCode: this.taskCode,
                axisType: this.spectrumYAxisType,
                spectrumEventType: this.spectrumType,
                store: getAccelerometerApiStore(this.pmoduleAccelerometer.type),
              });

              if (rawData.length) {
                const transdormedData = this.transformData(rawData);
                this.isRendering = true;
                this.chartData = transdormedData.chartData;
              }

              this.status = '';
              this.progress = 0;
              waterfallDiagramStoreModule.clearSettings();
              this.closeSSE();
            }
            this.progress = value.progress;
            this.total = value.total;
          }
        }
      } catch {
        this.error = true;
        this.closeSSE();
      }
    };
  }

  getSpectrumFreqFormatted(index: number, leftY: number, rightY: number, dataLength: number) {
    return Math.round((leftY + (index * (rightY - leftY)) / (dataLength - 1)) * 100) / 100;
  }

  transformData(sourceData: any[]) {
    this.minYChart = sourceData[2][1];
    this.maxYChart = sourceData[2][2];

    this.minY = sourceData[1][0][0];
    this.maxY = sourceData[1][sourceData[1].length - 1][1];

    this.dataLength = sourceData[2][0];

    const freqData = sourceData[1].map((element: any) => {
      const elementNew = element.map((x: any) =>
        this.getSpectrumFreqFormatted(x, this.minYChart, this.maxYChart, this.dataLength),
      );
      return elementNew;
    });

    const freqCenters = freqData.map((freq: any) => {
      return freq[0] + Math.floor((freq[1] - freq[0]) / 2);
    });

    this.rowsize = freqData[0][1] - freqData[0][0];

    let minAmplitude = Number.MAX_VALUE;
    let maxAmplitude = 0;
    let maxColSize = 0;
    const data = sourceData[0].map((row: any) => {
      //находим центр временного промежутка - центр столбца на диаграмме
      const center = row[0] + Math.floor((row[1] - row[0]) / 2);
      maxColSize = maxColSize < row[1] - row[0] ? row[1] - row[0] : maxColSize;
      return row[2].map((val: number, index: number) => {
        maxAmplitude = maxAmplitude < val ? val : maxAmplitude;
        minAmplitude = minAmplitude > val ? val : minAmplitude;
        return [center, freqCenters[index], val];
      });
    });

    if (minAmplitude == Number.MAX_VALUE) minAmplitude = 0;

    this.colsize = maxColSize;
    this.dataLength = sourceData[2][0];

    return {
      chartData: {data: flatten([...data]), minAmplitude, maxAmplitude, id: this.diagram.id},
    };
  }

  async beforeDestroy() {
    this.closeSSE();
    // если задача применения зума завершена и мы уходим со страницы, то мы должны очистить данные до применения зума, если они были
    if (
      (await waterfallDiagramStoreModule.getDataBeforeZoom()) &&
      !(await waterfallDiagramStoreModule.getWaterfallSettings())
    )
      waterfallDiagramStoreModule.clearDataBeforeZoom();
  }

  closeSSE() {
    if (this.evtSource) {
      this.evtSource.close();
      this.evtSource = null;
    }
  }

  async created() {
    await waterfallDiagramStoreModule.init();

    const settings = await waterfallDiagramStoreModule.getWaterfallSettings();
    if (settings && settings.taskCode) {
      this.heightToKeep = settings.heightToKeep;
      this.widthToKeep = settings.widthToKeep;
      this.aggregateType = settings.aggregateType;
      this.spectrumType = settings.spectrumType;
      this.offset = settings.offset;
      this.axisType = settings.axisType ?? DtcpAcceleromerModuleAxisType.X;
      if (settings.length) this.maxY = settings.offset + settings.length;
      if (settings.thiningFactor) this.thiningFactor = settings.thiningFactor;
      await this.connectSSE(this.taskCode);

      //Если был применен зум
      const data = await waterfallDiagramStoreModule.getDataBeforeZoom();
      if (data) {
        this.isInZoom = true;
      }
    }
  }

  async onParamsCancel() {
    // TODO: Сделать более общий механизм, учитывающий и остальные параметры
    this.spectrumType = this.copiedSpectrumType;
  }

  //Действия при установке параметров
  async onStart() {
    this.chartData.data = [];
    const params: WaterfallSettings = {
      accelerometerModuleId: this.pmoduleAccelerometer.id ?? 0,
      accelerometerModuleGuid: this.pmoduleAccelerometer.guid ?? '',
      currentDateTimeInterval: {...this.selectedInterval},
      spectrumType: this.spectrumType,
      aggregateType: this.aggregateType,
      heightToKeep: this.heightToKeep,
      widthToKeep: this.widthToKeep,
      offset: this.offset,
      parallelFactor: this.parallelFactor,
      axisType: this.axisType,
    };
    if (this.thiningFactor) params.thiningFactor = this.thiningFactor;
    if (this.pmoduleTaho) {
      params.tahoModuleId = this.pmoduleTaho.id;
      params.tahoModuleGuid = this.pmoduleTaho.guid;
    }

    this.error = false;
    try {
      await waterfallDiagramStoreModule.start({
        settings: params,
        store: getAccelerometerApiStore(this.pmoduleAccelerometer.type),
      });
      this.isInZoom = false;
    } catch {
      this.error = true;
    }
  }

  async stopTask() {
    await waterfallDiagramStoreModule.stop({
      accelerometerModuleId: this.pmoduleAccelerometer.id ?? 0,
      taskCode: this.taskCode,
      store: getAccelerometerApiStore(this.pmoduleAccelerometer.type),
    });
    this.closeSSE();
    this.status = '';
    this.progress = 0;
    this.total = null;
  }

  // Действие при сбросе зума
  async skipZoom() {
    if (this.isInZoom) {
      this.isInZoom = false;
      const data = await waterfallDiagramStoreModule.getDataBeforeZoom();
      if (data) {
        this.isRendering = true;
        this.chartData = {
          data: data.data,
          maxAmplitude: data.maxAmplitude,
          minAmplitude: data.minAmplitude,
          id: this.diagram.id,
        };
        this.minY = data.minY;
        this.maxY = data.maxY;
        this.colsize = data.colsize;
        this.rowsize = data.rowsize;
        waterfallDiagramStoreModule.clearDataBeforeZoom();
      }
    }
  }

  // Действия при зуме графика
  async onChartZoom(intervals: {indexInterval: IndexInterval; dateInterval: DateTimeInterval}) {
    this.isInZoom = true;

    const params: WaterfallSettings = {
      accelerometerModuleId: this.pmoduleAccelerometer.id ?? 0,
      accelerometerModuleGuid: this.pmoduleAccelerometer.guid ?? '',
      currentDateTimeInterval: {...this.selectedInterval},
      spectrumType: this.spectrumType,
      aggregateType: this.aggregateType,
      heightToKeep: this.heightToKeep,
      widthToKeep: this.widthToKeep,
      parallelFactor: this.parallelFactor,
      offset: this.offset,
      axisType: this.axisType,
    };
    if (this.thiningFactor) params.thiningFactor = this.thiningFactor;

    //Если ранее зум для текущих данных не применялся, то сохраняем их для восстановления после отмены зума
    if (!(await waterfallDiagramStoreModule.getDataBeforeZoom()))
      waterfallDiagramStoreModule.setDataBeforeZoom({
        data: this.chartData.data,
        minAmplitude: this.chartData.minAmplitude,
        maxAmplitude: this.chartData.maxAmplitude,
        minY: this.minY,
        maxY: this.maxY,
        rowsize: this.rowsize,
        colsize: this.colsize,
        dateTimeInterval: {...this.selectedInterval},
      });

    if (intervals.indexInterval) {
      const indexDiff = intervals.indexInterval.endIndex - intervals.indexInterval.startIndex + 1;
      params.offset = intervals.indexInterval.startIndex;
      params.length = indexDiff;

      this.xSoftMin = intervals.dateInterval.startDateTime as number;
      this.xSoftMax = intervals.dateInterval.endDateTime as number;
    }

    if (intervals.dateInterval) {
      params.currentDateTimeInterval = {...intervals.dateInterval};
    }

    try {
      this.error = false;
      await waterfallDiagramStoreModule.start({
        settings: params,
        store: getAccelerometerApiStore(this.pmoduleAccelerometer.type),
      });
    } catch {
      this.error = true;
    }
  }

  // сбрасываем флаг зума
  onResetIsInZoom() {
    this.isInZoom = false;
  }
}
